<template>
  <div class="settings-btn">
    <h2 class="headline">Action button</h2>
    <v-form class="form">
      <v-card>
        <content-field
          label="Text"
          v-model="formData.text"
          @input="$v.formData.text.$touch()"
          @blur="$v.formData.text.$touch()"
          :error="$v.formData.text"
        />
      </v-card>
      <v-card>
        <content-field
          label="Width"
          v-model="formData.width"
          @input="$v.formData.width.$touch()"
          @blur="$v.formData.width.$touch()"
          :error="$v.formData.width"
        />
      </v-card>
      <v-card>
        <content-field
          label="Font family"
          v-model="formData.font.family"
          @input="$v.formData.font.family.$touch()"
          @blur="$v.formData.font.family.$touch()"
          :error="$v.formData.font.family"
        />
      </v-card>
      <v-card>
        <content-field
          label="Text size"
          v-model="formData.font.size"
          @input="$v.formData.font.size.$touch()"
          @blur="$v.formData.font.size.$touch()"
          :error="$v.formData.font.size"
        />
      </v-card>
      <v-card>
        <e-color-picker
          label="Text color"
          :value="formData.font.color"
          @colorChange="onFontColorChange($event)"
        />
      </v-card>
      <v-card>
        <content-field
          label="Font weight"
          v-model="formData.font.weight"
          @input="$v.formData.font.weight.$touch()"
          @blur="$v.formData.font.weight.$touch()"
          :error="$v.formData.font.weight"
        />
      </v-card>
      <v-card>
        <e-color-picker
          label="Background color"
          :value="formData.background.color"
          @colorChange="onBgColorChange($event)"
        />
      </v-card>
      <v-card>
        <e-color-picker
          label="Hover background color"
          :value="formData.background.hover"
          @colorChange="onBgHoverColorChange($event)"
        />
      </v-card>

      <v-btn
        class="btn_submit"
        color="success"
        @click="submitForm"
        :disabled="$v.$invalid || !isWriteAvailable"
      >Update form
      </v-btn>
    </v-form>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { required } from 'vuelidate/lib/validators'
  import EColorPicker from '@/components/shared/EColorPicker'
  import { pathOr } from 'ramda'
  import mixins from '@/utils/mixins'

  export default {
    name: 'SettingsButton',
    mixins: [mixins.isWriteAvailable],
    components: {
      EColorPicker
    },
    data () {
      return {
        formData: {
          text: 'Submit',
          width: '100%',
          font: {
            family: 'Arial, Times, serif',
            size: '16px',
            color: { hex: '#0000ff' },
            weight: 'normal'
          },
          background: {
            color: { hex: '#00ff00' },
            hover: { hex: '#ff0000' }
          }
        },
        // DON'T DELETE! need for isWriteAvailable mixin
        scopeForWrite: 'blitz:write'
      }
    },
    validations: {
      formData: {
        text: { required },
        width: { required },
        font: {
          family: { required },
          size: { required },
          weight: { required }
        }
      }
    },
    computed: {
      ...mapGetters(['getButtonSettings'])
    },
    watch: {
      getButtonSettings () {
        this.setFormData()
      }
    },
    methods: {
      ...mapActions(['updateForm']),
      setFormData () {
        if (!this.getButtonSettings) return
        // shortcuts
        const feData = this.formData
        const beData = this.getButtonSettings

        this.formData.text = beData.text || feData.text
        this.formData.width = beData.width || feData.width
        this.formData.font = {
          family: pathOr(feData.font.family, ['font', 'family'], beData),
          size: pathOr(feData.font.size, ['font', 'size'], beData),
          color: pathOr(feData.font.color, ['font', 'color'], beData),
          weight: pathOr(feData.font.weight, ['font', 'weight'], beData)
        }
        this.formData.background = {
          color: pathOr(feData.background.color, ['background', 'color'], beData),
          hover: pathOr(feData.background.hover, ['background', 'hover'], beData)
        }
      },
      submitForm () {
        this.$v.$touch()
        if (this.$v.$invalid) return
        this.updateForm({
          button: this.formData
        })
      },
      onFontColorChange (newColor) {
        this.formData.font.color = newColor
      },
      onBgColorChange (newColor) {
        this.formData.background.color = newColor
      },
      onBgHoverColorChange (newColor) {
        this.formData.background.hover = newColor
      }
    },
    beforeMount () {
      this.setFormData()
    }
  }
</script>

<style lang="scss" scoped>
  .settings-btn {
    max-width: 480px;
  }

  .form {
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .headline {
    margin-bottom: 20px;
    text-align: center;
  }

  .card {
    padding: 10px;
    margin-bottom: 15px;
  }

  .btn {
    &_submit {
      margin: 0 auto;
      margin-top: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Blitz/Settings/button.vue